<template>
  <path
    d="M20 2.00024H12C6.38 2.00024 2 6.66024 2 12.2802C2 17.5002 6.49 22.0002 11.72 22.0002C17.39 22.0002 22 17.6202 22 12.0002V4.00024C22 2.90024 21.1 2.00024 20 2.00024ZM17 15.0002L14 13.0002V15.0002H7V9.00024H14V11.0002L17 9.00024V15.0002Z"
  />
</template>
